/*** IMPORTS FROM imports-loader ***/
(function() {

define(['jquery',
        'javascript-debounce',
        'window'
],
function ($,
        debounce,
        window) {
    
    var Carousel = function Carousel(config) {
        this.name = config.name;
        this.selectors = {
            parent: config.selector || '.pip-carousel',
            wrapper: config.wrapperSelector || '.pip-carousel-wrapper',
            stage: config.stageSelector || '.pip-carousel__stage',
            item: config.itemSelector || '.irg__carouselitem',
            nextButton: config.nextButton || '.button-next',
            prevButton: config.prevButton || '.button-prev'
        }
        this.config = {
            itemsPerPage: config.itemsPerPage || 5
        };
        this.classes = {
            carouselLoading: 'pip-carousel--loading'
        }
        this.events = {
            onInit: config.onInit || function() {},
            onNext: config.onNext || function() { return $.Deferred().resolve(); },
            onPrev: config.onPrev || function() {},
            onChange: config.onChange || function () { },
            renderSelectedItems: config.renderSelectedItems || function () {},
            onRenderComplete: function() {
                this.determineViewportBounds();
            }.bind(this)
        };

        this.viewModel = {
            render: function() {},
            slides: {
                current: 1,
                perPage: 5,
                total: config.itemTotal || 1
            },
            navigation: {
                next: {
                    hidden: false
                },
                prev: {
                    hidden: true
                }
            }
        };

        this.stagePosition = '0%';
    };

    Carousel.prototype.getWrapperWidth = function getWrapperWidth() {
        return $(this.selectors.wrapper, this.selectors.parent).width();
    }

    Carousel.prototype.findSlideEndpoints = function findSlideEndpoints() {
        this.viewModel.slides.maxDisplayable = (this.viewModel.slides.total - (this.viewModel.slides.total % this.viewModel.slides.perPage))
        this.viewModel.slides.endPoint = this.viewModel.slides.total + 1 - this.viewModel.slides.perPage
    }

    Carousel.prototype.showHideNavigation = function showHideNavigation() {
        // Pagination not possible
        if (this.viewModel.slides.perPage >= this.viewModel.slides.total) {
            this.viewModel.navigation.next.hidden = this.viewModel.navigation.prev.hidden = true;
        }
        // No nexting possible
        else if (this.viewModel.slides.current === this.viewModel.slides.endPoint) {
            this.viewModel.navigation.next.hidden = true;
            this.viewModel.navigation.prev.hidden = false;
        }
        // No prevving possible
        else if (this.viewModel.slides.current === 1) {
            this.viewModel.navigation.prev.hidden = true;
            this.viewModel.navigation.next.hidden = false;
        }
        // Normal behavior
        else {
            this.viewModel.navigation.prev.hidden = this.viewModel.navigation.next.hidden = false;
        }

        $(this.selectors.nextButton, this.selectors.parent).toggleClass('hidden', this.viewModel.navigation.next.hidden);
        $(this.selectors.prevButton, this.selectors.parent).toggleClass('hidden', this.viewModel.navigation.prev.hidden);
    }

    Carousel.prototype.determineViewportBounds = function determineViewportBounds() {
        var evalWidth = (this.getWrapperWidth() || $(window).width());
        this.viewModel.slides.perPage = 5;

        if (typeof this.config.itemsPerPage === 'number') {
            this.viewModel.slides.perPage = this.config.itemsPerPage;
        }
        else if (typeof this.config.itemsPerPage === 'object') {
            for (var viewport in this.config.itemsPerPage) {
                if (evalWidth >= viewport) {
                    this.viewModel.slides.perPage = this.config.itemsPerPage[viewport];
                }
            }
        }
        // When resizing, or on initial load, we'll
        // need to check if buttons should display
        this.findSlideEndpoints();
        this.showHideNavigation()
    }

    Carousel.prototype.scrollCarousel = function scrollCarousel(n) {
        this.viewModel.slides.current = n;

        // Check if the next or prev buttons will be necessary
        this.showHideNavigation();
        this.stagePosition = Math.ceil(-((100 / (this.viewModel.slides.perPage))*(n-1))) + '%';

        $(this.selectors.stage, this.selectors.parent).css({
            'transform':'translateX('+this.stagePosition+')',
            '-webkit-transform':'translateX('+this.stagePosition+')',
            '-ms-transform':'translateX('+this.stagePosition+')'
        })
        this.events.renderSelectedItems();
    }

    Carousel.prototype.next = function next() {
        $(this.selectors.parent).addClass(this.classes.carouselLoading);
        this.events.onNext().done(function (totalNumberOfItems) {
            if (totalNumberOfItems) {
                this.viewModel.slides.total = totalNumberOfItems;
            }
            this.determineViewportBounds();

            var prospectiveSlide = this.viewModel.slides.current + this.viewModel.slides.perPage;

            if (prospectiveSlide >= this.viewModel.slides.maxDisplayable) {
                prospectiveSlide = this.viewModel.slides.endPoint;
            }

            this.scrollCarousel(prospectiveSlide);

        }.bind(this))
        .always(function() {
            $(this.selectors.parent).removeClass(this.classes.carouselLoading);
        }.bind(this));
    }

    Carousel.prototype.prev = function prev() {
        this.events.onPrev();
        this.determineViewportBounds();

        var prospectiveSlide = this.viewModel.slides.current - this.viewModel.slides.perPage;

        if (this.viewModel.slides.current + this.viewModel.slides.perPage > this.viewModel.slides.maxDisplayable) {
            prospectiveSlide = this.viewModel.slides.maxDisplayable - this.viewModel.slides.perPage;
        }

        if (prospectiveSlide < 1) {
            prospectiveSlide = 1
        }

        this.scrollCarousel(prospectiveSlide);
    }

    Carousel.prototype.initEventListeners = function initEventListeners() {
        var that = this; 
        var namespace = 'click.' + this.name;
        $(window.document).off(namespace);
        $(window.document).on(namespace, this.selectors.parent + ' ' + this.selectors.nextButton, function () {
            debounce(that.next(), 250)
        });
        $(window.document).on(namespace, this.selectors.parent + ' ' + this.selectors.prevButton, function() {
            debounce(that.prev(), 250)
        });

        var startX, endX, startY, endY;
        var minDistance = 50;

        $(window.document).off('.slide').on('touchstart.slide touchend.slide touchmove.slide', this.selectors.wrapper, function(e) {
            var touches = e.originalEvent.touches;

            if (touches.length === 1) {
                if (e.type === 'touchstart') {
                    startX = touches[0].clientX;
                }

                if (e.type === 'touchmove') {
                    endX = touches[0].clientX;
                }
            }

            if (e.type === 'touchend' && Math.abs(endX - startX) > minDistance) {
                if (endX > startX) {
                    debounce(that.prev(), 250)
                } else {
                    debounce(that.next(), 250)
                }
            };
        });
    }

    return {
        init: function init(config) {
            return new Carousel(config);
        },
    }

});

}.call(window));